module.exports = __webpack_public_path__ + "static/media/select-arrow-up-enabled.e4d20791.svg";